<script setup>
import { Map } from 'ol'
import TileLayer from 'ol/layer/Tile'
import { ImageWMS, OSM, TileWMS, XYZ } from 'ol/source'
import View from 'ol/View'
import ZoomSlider from 'ol/control/ZoomSlider.js'
import {defaults as defaultControls} from 'ol/control/defaults.js'
import 'ol/ol.css'
import { onMounted, reactive, ref } from 'vue'
import { fromLonLat } from 'ol/proj'
import config from '@/common/config'
import { fetchImgData, get } from '@/common/util'
import { boundingExtent, getCenter } from 'ol/extent'
import LayerGroup from 'ol/layer/Group'
import BgMapSelector from './BgMapSelector.vue'
import ImageLayer from 'ol/layer/Image'
const props=defineProps(['width','height','layernms','sldbodies']),meta=reactive({layernms:props.layernms,sldbodies:props.sldbodies,width:'100%',height:'100%',onoverlay:true,layergroup:null})
,refreshLayers=(layernms,sldbodies)=>{
  meta.layernms=layernms
  meta.sldbodies=sldbodies
  initLayers()
},clearLayers=()=>{
  meta.layergroup.getLayers().clear()
},initLayers=(delexist=true)=>{
  meta.onoverlay=true
  if(delexist)clearLayers()
  if(!meta.layernms||!meta.layernms.length)return false
  for(let i=0;i<meta.layernms.length;i++){
    const sld=meta.sldbodies[i]
    const lnm=meta.layernms[i]
    const wmsparam={LAYERS:lnm,FORMAT:'image/png'}
    if(sld)wmsparam.SLD_BODY=sld
    const layer=new ImageLayer({
      source:new ImageWMS({url:config.backend+'wms',params:wmsparam,serverType: 'geoserver',imageLoadFunction:async(img, src)=>{
        const [base, queryString] = src.split('?')
        const searchParams = new URLSearchParams(queryString)
        const sldbd = searchParams.get('SLD_BODY')
        if (sldbd) {
          searchParams.delete('SLD_BODY')
          img.getImage().src = await fetchImgData('wms?'+searchParams.toString(),sldbd)
        } else {
          img.getImage().src = src;
        }
      }})
    })
    meta.layergroup.getLayers().push(layer)
  }
  return true
}
defineExpose({refreshLayers,clearLayers})
onMounted(()=>{
  const bottomLeft = fromLonLat([config.KoreaBbox.lonMin, config.KoreaBbox.latMin])
  const topRight = fromLonLat([config.KoreaBbox.lonMax,config.KoreaBbox.latMax])
  const extent = boundingExtent([bottomLeft,topRight])
  const cen = getCenter(extent)
  if(props.width)meta.width=props.width
  if(props.height)meta.height=props.height
  const layergroup=new LayerGroup({layers:[]}),basemapgroup=new LayerGroup()
  basemapgroup.set('nm','basemapgroup')
  meta.map=new Map({layers:[basemapgroup,layergroup],target:'previewmap',controls:defaultControls().extend([new ZoomSlider()])
    ,view:new View({extent:meta.extent,center:cen,zoom:6})})
  meta.basemapgroup=basemapgroup
  meta.layergroup=layergroup
  initLayers()
})
</script>
<template>
<v-card :width="meta.width" :height="meta.height">
  <div class="bgselwrap" style="position: absolute;z-index: 999;top:10px;left: 40px;width: 220px;">
    <bg-map-selector :map="meta.map"/>
  </div>
  <div id="previewmap" style="width: 100%;height: 100%;"/>
</v-card>
</template>
